import { useContext } from 'react'
import type { Integration } from '@/types/integration'
import { IntegrationContext } from '@/providers/integration-provider'

const defaultIntegrations = {
  integrations: [] as Integration[],
  enabledIntegrations: [] as Integration[],
  configuredIntegrations: [] as Integration[],
  getIntegration: () => undefined,
  toggleIntegration: async () => {},
  updateIntegrationConfig: async () => {},
  isConfigured: () => false,
  loading: false,
}

/**
 * Hook to access integration system
 *
 * @example
 * const { configuredIntegrations, getIntegration } = useIntegrations()
 *
 * const basecampIntegration = getIntegration('basecamp')
 * if (basecampIntegration?.configured) {
 *   // Show Basecamp UI
 * }
 */
export const useIntegrations = () => {
  const ctx = useContext(IntegrationContext)
  if (!ctx) {
    // Graceful fallback — can happen during React StrictMode double-render or error boundaries
    return defaultIntegrations
  }
  return ctx
}

